/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ScalarUnit } from './ScalarUnit';
import {
    ScalarUnitFromJSON,
    ScalarUnitFromJSONTyped,
    ScalarUnitToJSON,
} from './ScalarUnit';

/**
 * 
 * @export
 * @interface Scalar
 */
export interface Scalar {
    /**
     * 
     * @type {number}
     * @memberof Scalar
     */
    value?: number;
    /**
     * 
     * @type {ScalarUnit}
     * @memberof Scalar
     */
    unit?: ScalarUnit;
    /**
     * 
     * @type {string}
     * @memberof Scalar
     */
    $type?: ScalarTypeEnum;
}


/**
 * @export
 */
export const ScalarTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type ScalarTypeEnum = typeof ScalarTypeEnum[keyof typeof ScalarTypeEnum];



/**
 * Check if a given object implements the Scalar interface.
 */
export function instanceOfScalar(value?: unknown): value is Scalar {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ScalarTypeEnum)[0];
}

export function ScalarFromJSON(json: any): Scalar {
    return ScalarFromJSONTyped(json, false);
}

export function ScalarFromJSONTyped(json: any, ignoreDiscriminator: boolean): Scalar {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'unit': json['unit'] == null ? undefined : ScalarUnitFromJSON(json['unit']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ScalarToJSON(value?: Scalar | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value['value'],
        'unit': ScalarUnitToJSON(value['unit']),
        '$type': value['$type'],
    });
}

